import React from 'react';
import { observer } from 'mobx-react';
import Loader from 'react-simple-loading';
import Messages from './messages/Messages';
import MessageInput from './message-input/MessageInput';
import BannedSubInfo from './BannedSubInfo/BannedSubInfo';
import ExpiredSubInfo from './ExpiredSubInfo/ExpiredSubInfo';

import { RootStoreContext } from '../../../../../context';

import './Messaging.css';

@observer
class Messaging extends React.Component {

  static contextType = RootStoreContext;

  renderActiveConversation = () => {
    const {
      privateMessagingStore: {
        conversationSession: { loading, error, session },
        activeConversationHeader,
        isBanned
      },
      loggedInUser: { account: { anchorSubscriptions, anchor } }
    } = this.context;

    const isAnchor = !!anchor;
    
    if (activeConversationHeader && activeConversationHeader.username) {
      const subscription = anchorSubscriptions.find(sub => sub.anchorUsername === activeConversationHeader.username || sub.anchorNickname === activeConversationHeader.username);

      if (!subscription && !isAnchor) {
        return <ExpiredSubInfo anchorInfo={activeConversationHeader} />
      }
    }

    if (isBanned && !isAnchor) {
      return <BannedSubInfo anchorInfo={activeConversationHeader} />
    }

    return (
      <>
        {loading && <Loader />}
        {!loading && error && <div>{error}</div>}
        {session && !error && (
          <>
            <Messages />
            <MessageInput />
          </>
        )}
      </>
    )
  }

  render () {
    return (
      <div id="private-chat-messaging">
        {this.renderActiveConversation()}
      </div>
    );
  }
}

export default Messaging;